import { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import { notification } from 'redux-store/reducers/common-reducer';
import { checkForNewVersion } from 'modules/admin/reducers/version';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./version-checker.i18n.json'));

type Props = {
  dispatch: any,
  newVersionReleased: boolean
};

type State = {
  intervalId: number | null
}

class VersionChecker extends Component<Props, State> {
  static CHECK_INTERVAL = 30 * 1000;

  state = {
    intervalId: null
  };

  componentDidMount() {
    const intervalId = window.setInterval(() => {
      if (!document.hidden) {
        this.props.dispatch(checkForNewVersion());
      }
    }, VersionChecker.CHECK_INTERVAL);

    this.setState({ intervalId });
  }

  componentDidUpdate(prevProps) {
    const { newVersionReleased } = this.props;

    if (!isEqual(newVersionReleased, prevProps.newVersionReleased)) {
      window.clearInterval(this.state.intervalId ?? -1);
      this.notifyUser();
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.state.intervalId ?? -1);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.newVersionReleased;
  }

  notifyUser = () => {
    const message = __t('version_checker.version_check_new_version');
    const action = `<a onClick="window.location.reload()">
      ${__t('version_checker.version_check_click_to_refresh')}
    </a>`;

    this.props.dispatch(notification({
      type: 'info',
      message: `${message} ${action}`
    }));
  };

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    newVersionReleased: state.version.newVersionReleased
  };
}

export default connect(mapStateToProps)(VersionChecker);
